'use client';

import { useParams } from 'next/navigation';
import { Container, Grid } from '@mantine/core';
import { SquareCard } from './SquareCard/SquareCard';

export const SquareCardList = ({ services }: { services: any[] }) => {
  const { lang } = useParams();
  if (!services || services.length === 0) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', fontStyle: 'italic' }}>
        Aucun service disponible pour le moment.
      </div>
    );
  }

  return (
    <div>
      <Container my="md">
        <Grid gutter="lg">
          {services.map((service: any, index: number) => (
            <Grid.Col
              span={{ base: 12, sm: 4 }}
              // @ts-ignore
              key={`${service.title[lang] ? service.title[lang] : service.title}${index}`}
            >
              <SquareCard data={service} />
            </Grid.Col>
          ))}
        </Grid>
      </Container>
    </div>
  );
};
